/**
 * PortalTabs
 *
 * Handles the creating and managing the account selection widget
 */

// the constructor for this object
function PortalButtonTabs() { }

// the object
PortalButtonTabs.prototype = {
    constructor: PortalButtonTabs,
    
    // the selector for the box tabs element
    buttonTabsSelector: false,
    
    // the callback to be executed when a tab is clicked
    tabClickCallback: null,
    
    init: function(selector)
    {
        // store the selector
        this.buttonTabsSelector = selector;
    
        // set the current tab and target from the url params
        this._setFromUrlParams();
    
        // register events
        this._registerEvents();
    },
    
    // set the current tab and target from url params
    _setFromUrlParams: function()
    {
        var tabTarget = PortalHelper.getUrlParameter('tab-target');
        var tabButton = $('a[data-target="' + tabTarget + '"]');
        
        if (tabTarget && tabButton.length) {
            this._toggleTab(tabButton);
        }
    },
    
    // create the on click events for the tabs
    _registerEvents: function()
    {
        var self = this;
    
        // register the tab button clicks
        $(this.buttonTabsSelector).each(function() {
            $('a', this).each(function() {
                $(this).on('click', function() {
                    
                    var tabTarget = $(this).attr('data-target');
                    self._setUrlTabTarget(tabTarget);
                    
                    self._toggleTab(this);
                
                });
            });
        });
    },
    
    // change the url parameters
    _setUrlTabTarget: function(tabTarget)
    {
        // get all the actual params from the url
        var allUrlParams = PortalHelper.getAllUrlParameters();
        
        // add the tab target param
        allUrlParams['tab-target'] = tabTarget;
        
        // build the url and replace the current history
        var paramString = '?' + $.param(allUrlParams);
        history.replaceState(null, null, paramString);
    },
    
    // toggle 
    _toggleTab: function(tabElement)
    {
        var tabContainer = $(tabElement).parent();
    
        // set this tab to visible
        $('a', tabContainer).removeClass('current');
        $(tabElement).addClass('current');
        
        // set the content to visible
        var tabTarget = $(tabElement).attr('data-target');
        
        $('.button-tab-target').removeClass('current');
        $('#' + tabTarget).addClass('current');

        // execute the callback if applicable
        if (typeof this.tabClickCallback == 'function') {    
            this.tabClickCallback(tabTarget);
        }
        
    },
    
}
